import React from 'react';
import { observer } from 'mobx-react-lite';
import { Button, colors, InputText } from '@insurancemenu/imenu-components-lib';
import FormModal from 'components/common/modals/FormModal';
import { Delete } from '@insurancemenu/imenu-components-lib/dist/icons';
import ManageTagModalStore from 'store/modules/proposal/ui/manageTagModalStore';
import IProposalPageStore from 'store/modules/proposal/iProposalPageStore';
import { createStyles } from './styles';

interface ModalProps<PageStore extends IProposalPageStore> {
  store: ManageTagModalStore<PageStore>;
}

function ManageTagModal<PageStore extends IProposalPageStore>({ store }: ModalProps<PageStore>): JSX.Element {
  const {
    isLoading,
    formTag,
    tagError,
    modalIsVisible,
    isTagAlreadyAdded,
    currentTag,
    setTag,
    closeModal,
    manageTag,
    isDataValid,
    removeTag,
  } = store;

  const classes = createStyles();
  return (
    <FormModal
      show={modalIsVisible}
      onClose={closeModal}
      id="manage-tag"
      title={isTagAlreadyAdded ? 'Edit or Remove Product Tag' : 'Add Product Tag'}
      subtitle={
        isTagAlreadyAdded ? (
          <span>
            Update the tag name or remove it from the product. <br /> This tag is displayed on the product and can be
            edited anytime.
          </span>
        ) : (
          <span>
            Enter a new tag name to add it to the product. <br /> This tag will be displayed on the product and can be
            edited anytime.
          </span>
        )
      }
      isFormValid={isDataValid()}
      onSubmit={manageTag}
      loading={isLoading}
      formContent={
        <div className={classes.formContent}>
          <InputText
            label="Tag name"
            name="tag"
            value={formTag}
            onChange={setTag}
            validationPassed={!tagError}
            validationMessage={tagError || ''}
            maxLength={20}
            width="30rem"
          />
          {/* Show remove tag button only if If initially tag was provided in Product */}
          {isTagAlreadyAdded && (
            <Button
              type="text"
              color="custom"
              customColor={colors.red[600]}
              leftIconProp={<Delete />}
              onClick={removeTag}
              className={classes.actionButton}
            >
              {` Remove ${currentTag} tag`}
            </Button>
          )}
        </div>
      }
      closeButtonText="Cancel"
      submitButtonText="Save"
    />
  );
}

export default observer(ManageTagModal);
